var ZeroDisplayType = /* @__PURE__ */ ((ZeroDisplayType2) => {
  ZeroDisplayType2["Included"] = "included";
  ZeroDisplayType2["None"] = "none";
  ZeroDisplayType2["Zero"] = "zero";
  return ZeroDisplayType2;
})(ZeroDisplayType || {});

export { ZeroDisplayType };
//# sourceMappingURL=ep-pricing-esm-types-differential-price.types.js.map
